
import { Component, Prop, Vue } from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-category-view',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  @Prop() readonly categoryId: number;
  @Prop() readonly catalogData: object;
  @Prop() readonly dataSource: string;
  @Prop() readonly imageBaseUrl: string;
  @Prop({ default: '' }) readonly categoryName: string;
  @Prop() readonly categoryUsp: string | null;
  @Prop({ default: () => [] }) private wishlistItems: Array<object>;
  @Prop() private readonly customerGroupId: number;

  private created(): void {
    this.$store.commit(`${this.dataSource}/SET_CATEGORY_ID`, this.categoryId);
    this.$store.commit(`${this.dataSource}/SET_API_RESPONSE`, this.catalogData);

    window.onpopstate = ({ state }) => {
      this.$store.commit(`${this.dataSource}/SET_CATEGORY_ID`, null === state ? this.categoryId : state['categoryId']);
      this.$store.commit(`${this.dataSource}/SET_API_RESPONSE`, null === state ? this.catalogData : state['catalogData']);
    };

    history.replaceState({ categoryId: this.categoryId, catalogData: this.catalogData }, document.title);
  }
}
